import { SessionStorageOtpFlowMemory } from '@/modules/auth/infra'
import type { OtpFlowMemory } from '@/modules/auth/infra'

let cached: OtpFlowMemory | null = null

export function makeOtpFlowMemory(): OtpFlowMemory {
  if (cached) return cached
  cached = new SessionStorageOtpFlowMemory()
  return cached
}
